import { ajax } from '../../../services/helper'
class ApiService {

    getEmployeesMovementData = (from,to) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeMovements/list?from="+from+"&to="+to
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addEmployeeMovement = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeMovements/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getKitchensListData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/kitchens/getCombo?type=city_scope"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

 editEmployeeMovement = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employeeMovements/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/services/apiservices.js